import React, { useRef } from "react";

interface FileUploaderProps {
    disabled: boolean;
    buttonClass?: string;
    buttonText?: string;
    loading?: boolean;
    onFileSelect: (files: File[]) => void;
    children?: React.ReactChild;
}

export default function FileSelect({
    disabled,
    buttonClass,
    children,
    onFileSelect
}: FileUploaderProps) {
    const fileRef = useRef<any>(null);

    function onChange() {
        const files: File[] = [];

        for (let i = 0; i < fileRef.current.files.length; i++) {
            files.push(fileRef.current.files[i]);
        }

        onFileSelect(files);
    }

    function onClick() {
        fileRef.current.value = "";
    }

    return (
        <div className={buttonClass} role="button" onClick={onClick}>
            <label htmlFor="input">{children}</label>

            <input
                ref={fileRef}
                type="file"
                id="input"
                style={{ display: "none" }}
                multiple
                onChange={onChange}
                disabled={disabled}
            />
        </div>
    );
}
